import { render, staticRenderFns } from "./label-btn.vue?vue&type=template&id=1f1c4a52&scoped=true&"
import script from "./label-btn.vue?vue&type=script&lang=ts&"
export * from "./label-btn.vue?vue&type=script&lang=ts&"
import style0 from "./label-btn.vue?vue&type=style&index=0&id=1f1c4a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1c4a52",
  null
  
)

export default component.exports